// ========================================
// ================== V3 ==================
// ========================================

import { updateObject } from "../../helpers/index";
import * as aTypes from "../actions/actionTypes";

const initialState = {
  myUsers: null,
  myUsers_error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case aTypes.V3_MY_USERS_SET:
      return fetchMyUsersSet(state, action);
    case aTypes.V3_MY_USERS_FETCH_FAIL:
      return fetchMyUsersSetFail(state, action);
    default:
      return state;
  }
};

const fetchMyUsersSet = (state, action) => {
  return updateObject(state, {
    myUsers: action.myUsers,
  });
};

const fetchMyUsersSetFail = (state, action) => {
  return updateObject(state, {
    myUsers_error: action.error,
  });
};

export default reducer;
